<template>
  <div class="flex">
    <button
      @click="toggleModal"
      :aria-label="
        auth.user
          ? ui.showLogin
            ? 'Close Profile Modal'
            : 'Open Profile Modal'
          : 'Open Login Modal'
      "
      class="form-toggle button-style btn-add2 radius-0 tr-all-03 center textUpper z-1000"
    >
      {{
        auth.user
          ? ui.showLogin
            ? 'CLOSE'
            : 'PROFILE'
          : ui.showLogin
            ? 'CLOSE'
            : 'LOGIN'
      }}
    </button>

    <ModalLogin
      v-if="ui.showLogin && !auth.user"
      :visible="ui.showLogin"
      @close="closeModal"
    />
    <ModalProfile
      v-if="ui.showLogin && auth.user"
      :visible="ui.showLogin"
      @close="closeModal"
    />
  </div>
</template>

<script setup>
// src/components/navigation/MainLogin.vue
import { computed } from 'vue'
import { usePocketAuthStore } from '@/stores/usePocketAuthStore'
import { useUiState } from '@/stores/useUiState'
import ModalLogin from '@/components/navigation/ModalLogin.vue'
import ModalProfile from '@/components/navigation/ModalProfile.vue'

const auth = usePocketAuthStore()
const ui = useUiState()

const showLogin = computed(() => ui.showLogin)

const toggleModal = () => {
  if (!ui.showLogin) {
    ui.closeAll()
    ui.showLogin = true
  } else {
    ui.showLogin = false
  } // ← this closing brace was missing
}

const closeModal = () => {
  ui.showLogin = false
}
</script>
